import { render, staticRenderFns } from "./nullified_disclosure.vue?vue&type=template&id=547db212"
import script from "./nullified_disclosure.vue?vue&type=script&lang=js"
export * from "./nullified_disclosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports